import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

/** Mecanismo de firma seleccionado en el sidebar (Propuesta 5B). */
export type SignMechanism = 'token-virtual' | 'p10' | 'token-fisico' | 'rse';

@Injectable({
  providedIn: 'root'
})
export class SignMechanismService {
  /** Primera opción del menú: Certifirma Digital Virtual con OTP */
  private mechanism$ = new BehaviorSubject<SignMechanism>('rse');

  get current(): SignMechanism {
    return this.mechanism$.value;
  }

  get value$(): Observable<SignMechanism> {
    return this.mechanism$.asObservable();
  }

  setMechanism(mechanism: SignMechanism): void {
    this.mechanism$.next(mechanism);
  }
}
